import { api, buildQuery, type Page } from "./api";

export interface User {
  id: number;
  name: string;
  email: string;
  role_id: number;
  is_active: boolean;
  phone: string | null;
  client_id: number | null;
  avatar_url: string | null;
  join_date: string;
  last_active: string | null;
  created_at: string;
  updated_at: string | null;
  role_name: string;
  department_id: number | null;
  department_name: string;
  client_name: string | null;
}

export interface UserCreate {
  name: string;
  email: string;
  password: string;
  role_id: number;
  is_active?: boolean;
  phone?: string;
  client_id?: number;
  avatar_url?: string;
}

export interface UserFilters {
  skip?: number;
  limit?: number;
  q?: string;
  role_id?: number;
  is_active?: boolean;
  client_id?: number;
}

export interface NotificationPreference {
  user_id: number;
  notification_type_key: string;
  send_email: boolean;
  send_in_app: boolean;
  send_sms: boolean;
}

export const usersService = {
  list(filters: UserFilters = {}): Promise<Page<User>> {
    return api.get(`/users/${buildQuery(filters)}`);
  },

  get(id: number): Promise<User> {
    return api.get(`/users/${id}`);
  },

  create(data: UserCreate): Promise<User> {
    return api.post("/users/", data);
  },

  update(id: number, data: Partial<UserCreate>): Promise<User> {
    return api.patch(`/users/${id}`, data);
  },

  delete(id: number): Promise<void> {
    return api.delete(`/users/${id}`);
  },

  getNotificationPreferences(userId: number): Promise<NotificationPreference[]> {
    return api.get(`/users/${userId}/notification-preferences`);
  },

  saveNotificationPreferences(userId: number, prefs: Omit<NotificationPreference, "user_id">[]): Promise<NotificationPreference[]> {
    return api.put(`/users/${userId}/notification-preferences`, prefs);
  },
};
